import Image from "next/image"
import { useTranslation } from "next-i18next";

const UninterruptedSupportWithMakdos = () => {
    const { t } = useTranslation(["common", "homepage", "email"]);

    return (
        <div className="container mx-auto">
            <div className="grid items-center gap-5 py-12 lg:grid-cols-2">
                <div className="order-2 lg:order-1">
                    <Image src={"/UninterruptedSupportWithMakdos.svg"} width={538} height={431} alt={t("email:uninterruptedSupportWithMakdos")} title={t("email:uninterruptedSupportWithMakdos")} />
                </div>

                <div className="order-1 px-2 lg:order-2 lg:px-0">
                    <h2 className="pb-6 text-3xl font-bold text-titleColor lg:text-4xl">{t("email:uninterruptedSupportWithMakdos")}</h2>
                    <div className="pb-4 text-sm text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:uninterruptedSupportWithMakdosDesc1") }}></div>
                    <p className="pb-4 text-sm text-textGray lg:text-base">{t("email:uninterruptedSupportWithMakdosDesc2")}</p>
                    <p className="text-sm font-bold text-textGray lg:text-base">{t("email:uninterruptedSupportWithMakdosDesc3")}</p>
                </div>
            </div>
        </div>
    )
}

export default UninterruptedSupportWithMakdos